import url from './url';



export default url(({ userId = ':userId', deviceId = ':deviceId' }) => `/profiles/${userId}/devices/${deviceId}/purchases`);
